<template>
 <div class="howtoBox">
  <slick ref="slick":options="slickOptions" class="howtoSlider">
    <div class="bx hw01">
      <h3>合戦の準備 ①</h3>
      <div class="flex">
        <div class="box">
          <p class="tl">各プレイヤーに<br>
            カード2枚、コイン5枚を配る。</p>
          <p>※2人プレイの場合はカード4枚<br>
            ※プレイヤーの数に応じて、山札からカードを取り除く。（別紙）</p>
        </div>
        <div class="map"><img src="/image/howto01.png" width="243" alt=""/></div>
      </div>
    </div>
    <div class="bx hw02">
      <h3>合戦の準備 ②</h3>
      <div class="flex">
        <div class="box">
          <p>山札は裏面にして各プレイヤーの中央に置く。 山札から一枚とり山札の横に<span>裏面にして置き</span>、これをカード置場とする。</p>
          <p>各プレイヤー1枚ずつ、中央にコインを出し、<span>その中の1枚は取り除く<br>
            <span class="ti">（箱の中などに入れておく）。</span></span></p>
          <p>いざ、合戦へ！</p>
        </div>
        <div class="map"><img src="/image/howto02.png" width="406" alt=""/>
          <p>例）4人プレイの場合</p>
        </div>
      </div>
    </div>
    <div class="bx hw03">
      <h3>合戦 ①</h3>
      <div class="flex">
        <div class="box">
          <p>山札から1枚カードを引き、3枚になった手札の中から、使いたい効果を持つカード1枚を表向きにして置場に出す。</p>
          <p>※「一揆」するときは農民を同時に2枚出し、直ちに山札から1枚引き、手札を2枚に戻します。</p>
          <p>※相手からの攻撃でカードを失ったら、直ちに山札からカードを補充し手札を2枚に戻します。 </p>
        </div>
        <div class="map"><img src="/image/howto03.png" width="300" alt=""/></div>
      </div>
    </div>
    <div class="bx hw04">
      <h3>合戦 ②</h3>
      <div class="flex">
        <div class="box">
          <p>合戦①を各プレイヤーが時計回りに行なっていき、（a）または（b）の条件になったプレイヤーが中央のコイン置場にある全てのコインを得られる。</p>
          <ul class="clearfix">
            <li>
              <div class="base gr">
                <div>
                  <p>・山札が全て無くなった時または<br>
                    ・帝カードが使われた時に</p>
                  <span class="cl ti">（a）</span> 手札のHONORポイントの合計が多いプレイヤー<br>
                  <span class="ti">（出された帝のポイントは含まれない）</span> </div>
              </div>
            </li>
            <li>
              <div class="base">
                <div>または</div>
              </div>
            </li>
            <li>
              <div class="base gr">
                <div><span class="cl ti">（b）</span>合戦の<br>
                  最後の一人</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bx hw05">
      <h3>合戦 ③</h3>
      <div class="flex">
        <div class="box">
          <p>次の合戦は、前の合戦の勝者からスタートする。（合戦の準備①へ）</p>
          <p><span>次の合戦を行うためのコインを持たない</span>プレイヤーが出たらゲーム終了。<br>
            その時一番多くのコインを持っているプレイヤーが天下人となる。</p>
        </div>
        <div class="map"><img src="/image/howto04.png" width="374"  alt=""/></div>
      </div>
    </div>
    <div class="bx hw06">
      <h3>攻防について ①</h3>
      <div class="flex">
        <div class="box">
          <ul class="clearfix">
            <li><div class="base"><img src="/image/howto05.png" width="413" alt=""/></div></li>
            <li>
              <div class="base"><p>武将、軍師、大名または農民2枚で相手に攻撃を仕掛け、勝てば合戦のサイクルから攻撃した相手を排除することができる。</p></div>
            </li>
          </ul>
          <p>各合戦の自分の初ターン前に攻撃を受けた場合、コインを1枚払うことで攻撃をブロックできる。</p>
        </div>
      </div>
    </div>
    <div class="bx hw07">
      <h3>攻防について ②</h3>
      <div class="flex">
        <div class="box">
          <ul class="t1 clearfix">
            <li>
              <div class="base">
                <p>カードはそれぞれ、固有のBattleポイント（BTL）、Honorポイント（HNR）を持ちます。</p>
              </div>
            </li>
            <li>
              <div class="base"><img src="/image/howto06-2.png" width="277"  alt=""/></div>
            </li>
          </ul>
          <ul class="t2 clearfix">
            <li>
              <div class="base"><img src="/image/howto06-1.png" width="298"  alt=""/></div>
            </li>
            <li>
              <div class="base">
                <p>攻撃側は攻撃に使用した<span class="bl">カード1枚のBTL</span>、<span class="rd">防御側は手札2枚の合計BTL</span>で勝負します。 BTL総数が攻撃側より少ない場合、合戦から除外され、次の合戦を待ちます。 攻撃側は負けても何も起きません。</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </slick>
  <p class="detail">詳しくは<a href="/pdf/rulebook_zipang_jp.pdf" target="_blank">ルールブック[PDF]</a>をご確認ください。</p>
</div>
</template>

<script>
    // vue-slickをインポート
    import Slick from 'vue-slick';
    export default {
        components: { Slick },
        data() {
            return {
                // slickの設定
                slickOptions: {
                    lazyLoad: 'ondemand',
    autoplay: false,
    dots: true,
    arrows: true 
                },
            };
        }
    }
</script>